import React, { useState, useEffect } from 'react';
import { Modal, Button, Divider } from 'antd';
import {
  BorderOutlined,
  CloseOutlined,
  MinusSquareOutlined,
} from '@ant-design/icons';

import './style';

export default React.forwardRef((props, ref) => {
  const { isMaximize, title, width, afterClose, showMax, body, footer, visible, onCloseCallback } = props;
  const [maximize, setMaximize] = useState(isMaximize || false);
  useEffect(() => {
    if (!visible && !isMaximize) {
      setMaximize(false);
    }
  }, [visible]);

  var w = //1540 || 
     window.innerWidth * 0.95
    || document.documentElement.clientWidth
    || document.body.clientWidth;

  var h = window.innerHeight
    || document.documentElement.clientHeight
    || document.body.clientHeight;
  const maxWidth = maximize ? w : width;
  const maxHeight = maximize? h * w/document.documentElement.clientWidth - 42 : undefined;
  return (
    
      <Modal width={maxWidth} afterClose={afterClose} centered={true} closable={false} visible={visible} footer={null} destroyOnClose={true} maskClosable={false}>
        <div className="page-header">
          <div className="title">
            {title}
          </div>
          <div className="button">
            {showMax !== false && <Button onClick={() => setMaximize(!maximize)} type="text" style={{ color: "white" }} icon={maximize ? <MinusSquareOutlined /> : <BorderOutlined />}></Button>}
            <Button onClick={onCloseCallback} type="text" style={{ color: "white" }} icon={<CloseOutlined />}></Button>
          </div>
        </div>
        <div style={{height: maxHeight}} className={`page-body ${maximize ? 'page-body-max' : ''}`}>
          {visible && body}
        </div>
        {
          footer && (<Divider style={{ margin: '0' }} />)
        }
        {
          footer && (
            <div className="page-footer">
              {footer}
            </div>)
        }
      </Modal>

  );
});
